import '@fortawesome/fontawesome-free/css/all.css';
import CssBaseline from '@mui/material/CssBaseline';
import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';

import type { Direction } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material/styles';

import { StyledEngineProvider } from '@mui/material/styles';

import { createTheme } from '@mui/material/styles';

import { buttonCustomizations } from './overrides/buttons';
import { chipCustomizations } from './overrides/chips';
import { cssBaselineCustomizations } from './overrides/cssBaseline';
import { textFieldCustomizations } from './overrides/inputs';
import { linkCustomizations } from './overrides/links';
import { listItemButtonCustomizations } from './overrides/listItemButtons';
import { paperCustomizations } from './overrides/surface';
import { tabsCustomizations } from './overrides/tabs';
import { typographyCustomizations } from './overrides/typography';
import { dataGridCustomizations } from './overrides/dataGrid';
import {
  colorSchemes,
  mixins,
  shadows,
  shape,
  typography,
} from './themePrimitives';

export default function AppTheme({ children }: PropsWithChildren) {
  const theme = useMemo(
    () =>
      createTheme({
        direction: 'ltr' as Direction,
        mixins,
        shape,
        colorSchemes,
        typography,
        shadows,
                components: {
                  ...buttonCustomizations,
                  ...chipCustomizations,
                  ...cssBaselineCustomizations,
                  ...dataGridCustomizations,
                  ...linkCustomizations,
                  ...listItemButtonCustomizations,
                  ...paperCustomizations,
                  ...tabsCustomizations,
                  ...textFieldCustomizations,
                  ...typographyCustomizations,
                },
      }),
    [],
  );
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
